import React from 'react';
import Icon from './Icon';
import {IconProps} from './IconProps';

export default function IconLock({className, height, title}: IconProps) {
  return (
    <Icon className={className} height={height} title={title}>
      M5.7019 2.4519C6.3114 1.84241 7.13805 1.5 8 1.5C8.86195 1.5 9.6886 1.84241 10.2981 2.4519C10.9076 3.0614 11.25
      3.88805 11.25 4.75V6H4.75V4.75C4.75 3.88805 5.09241 3.0614 5.7019 2.4519ZM3.25 6V4.75C3.25 3.49022 3.75044 2.28204
      4.64124 1.39124C5.53204 0.500445 6.74022 0 8 0C9.25978 0 10.468 0.500445 11.3588 1.39124C12.2496 2.28204 12.75
      3.49022 12.75 4.75V6H13.25C14.7688 6 16 7.23122 16 8.75V15.25C16 16.7688 14.7688 18 13.25 18H2.75C1.23122 18 0
      16.7688 0 15.25V8.75C0 7.23122 1.23122 6 2.75 6H3.25ZM12 7.5H4H2.75C2.05964 7.5 1.5 8.05964 1.5 8.75V15.25C1.5
      15.9404 2.05964 16.5 2.75 16.5H13.25C13.9404 16.5 14.5 15.9404 14.5 15.25V8.75C14.5 8.05964 13.9404 7.5 13.25
      7.5H12Z
    </Icon>
  );
}
